export default __webpack_public_path__ + "static/media/quick_action_dialog_import.b6f2cabe.svg";